module.exports = __webpack_public_path__ + "img/ocr.98b1424e.svg";